<template>
    <div>
        <a-table
            :key="'vtable-' + renderCount"
            :columns="this.getCols()"
            :dataSource="items()"
            :locale="{
                emptyText: $t('message.noRePresentativeFound'),
            }"
            rowKey="_id"
            size="small"
            @change="tableChange"
        >
            <div :key="'isOnlineSlot-' + $i18n.locale" slot="isOnlineSlot" slot-scope="data, item">
                <span
                    v-if="'undefined' !== typeof item.isOnline && item.isOnline"
                    :class="statuses.find((s) => s.status === item.status).class"
                >
                    <font-awesome-icon :icon="statuses.find((s) => s.status === item.status).icon" class="mr-2" />
                    {{ $t(statuses.find((s) => s.status === item.status).langKey) }}
                </span>
                <span v-else>
                    <font-awesome-icon class="mr-2" icon="power-off" />
                    {{ $t("message.offline") }}
                </span>
            </div>
        </a-table>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faClock, faMinusCircle, faPowerOff, faGlobeEurope } from "@fortawesome/free-solid-svg-icons";
import * as _ from "lodash";
import { log2 } from "../utils/log2";
import { tableSorter } from "../utils/utils";

library.add(faCheckCircle, faClock, faMinusCircle, faPowerOff, faGlobeEurope);

const log = log2("PrivateChatRepresentative");

export default {
    name: "PrivateChatRepresentative",
    data() {
        return {
            showOnlineAgents: true,
            isBusy: true,
            statuses: [
                {
                    status: "Online",
                    langKey: "message.online",
                    class: "text-primary",
                    icon: "check-circle",
                    order: 1,
                },
                {
                    status: "Away",
                    langKey: "message.beRightBack",
                    class: "text-warning",
                    icon: "clock",
                    order: 2,
                },
                {
                    status: "Busy",
                    langKey: "message.busy",
                    class: "text-danger",
                    icon: "minus-circle",
                    order: 3,
                },
                {
                    status: "Offline",
                    langKey: "message.offline",
                    class: "text-dark",
                    icon: "power-off",
                    order: 4,
                },
            ],
            fields: [
                {
                    key: "isOnline",
                    label: this.$t("message.status"),
                },
                {
                    key: "name",
                    label: this.$t("message.repName"),
                },
            ],
            renderCount: 0,
            currentSort: {
                columnKey: "isOnline",
                order: "ascend",
            },
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users,
        }),
    },

    methods: {
        ...mapActions({}),
        getCols() {
            return [
                {
                    title: this.$t("message.repName"),
                    dataIndex: "name",
                    key: "name",
                    ...tableSorter("name", "string", this.currentSort),
                    width: "60%",
                },
                {
                    title: this.$t("message.status"),
                    dataIndex: "isOnline",
                    key: "isOnline",
                    ...tableSorter("isOnline", "string", this.currentSort),
                    scopedSlots: { customRender: "isOnlineSlot" },
                    width: "40%",
                },
            ];
        },
        items() {
            return this.users.data.filter((x) => x.isOnline);
        },
        tableChange(pagination, filters, sorter) {
            log("tableChange", { pagination, filters, sorter });
            this.defaultPageSize = pagination.pageSize;
            log("tableChange", { pagination, filters, sorter });
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log("show me current Sort", {
                currentSort: this.currentSort,
                newSort,
            });
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
    },

    watch: {
        users(newValue, old) {
            log("users changed");
            if (!_.isEqual(old, newValue)) {
                log("$forceUpdate running");
                this.$forceUpdate();
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
